const ALPHABET = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/** Mot de passe provisoire de 16 caractères sans signe ambigu (l, I, O, 0, 1), groupés par quatre. */
export function motDePasseProvisoire(): string {
  const tirage = new Uint32Array(16);
  crypto.getRandomValues(tirage);
  const caracteres = Array.from(tirage, (n) => ALPHABET[n % ALPHABET.length]).join('');
  return caracteres.match(/.{4}/g)!.join('-');
}
